import { createI18n } from '@upme/i18n';
import { detectAdminLocale } from './detect';
import { appResources } from './resources';

export const i18n = createI18n({ lng: detectAdminLocale(), resources: appResources });

export { appResources };
